import { ConversationFilterEnum, ConversationPriorityEnum } from "common/enums"
import { PaletteColor } from "@mui/material"
import { defaultColorPallete } from "utils"

export const ConversationsFilterTypeMap: Record<ConversationFilterEnum, () => string> = {
    [ConversationFilterEnum.ALL]: () => "Todas",
    [ConversationFilterEnum.HIGH]: () => "Emergencial",
    [ConversationFilterEnum.MEDIUM]: () => "Urgente",
    [ConversationFilterEnum.LOW]: () => "Não Urgente",
    [ConversationFilterEnum.GROUP]: () => "Grupos",
    [ConversationFilterEnum.NO_PRIORITY]: () => "Mais Recentes"
}

export function mapConversationPriorityColor(
    priority: ConversationFilterEnum | ConversationPriorityEnum
  ): PaletteColor {
    const priorityColorMapping: Record<ConversationFilterEnum | ConversationPriorityEnum, PaletteColor> = {
        [ConversationFilterEnum.HIGH]: defaultColorPallete.error,
        [ConversationFilterEnum.MEDIUM]: defaultColorPallete.warning,
        [ConversationFilterEnum.LOW]: defaultColorPallete.success,
        [ConversationFilterEnum.ALL]: defaultColorPallete.info,
        [ConversationFilterEnum.GROUP]: defaultColorPallete.info,
        [ConversationFilterEnum.NO_PRIORITY]: defaultColorPallete.emerald
    }
  
    return priorityColorMapping[priority] ??  defaultColorPallete.emerald
  }

  export function mapConversationFilterOptionsColor(
    option: ConversationFilterEnum
  ): PaletteColor {
    const filterOptionColorMapping: Record<ConversationFilterEnum, PaletteColor> = {
        [ConversationFilterEnum.HIGH]: defaultColorPallete.error,
        [ConversationFilterEnum.MEDIUM]: defaultColorPallete.warning,
        [ConversationFilterEnum.LOW]: defaultColorPallete.success,
        [ConversationFilterEnum.ALL]: defaultColorPallete.info,
        [ConversationFilterEnum.GROUP]: defaultColorPallete.info,
        [ConversationFilterEnum.NO_PRIORITY]: defaultColorPallete.emerald
    }
  
    return filterOptionColorMapping[option] ??  defaultColorPallete.emerald
  }
  
